import { createContext, useContext } from 'react';

import { Auth } from 'api';
import { OverlayData } from 'types';

export type Context = {
  auth: Auth;
  overlay?: OverlayData | null;
  setOverlay: (overlay: OverlayData | null) => void;
};

export const useAppContext = () => useContext(AppContext);

const AppContext = createContext<Context>({
  auth: { status: 'loggedOut', setToken: () => {} },
  setOverlay: () => {},
});

export default AppContext;
